import {
  getMidPoint,
  getPointOnTheLine,
} from "../../../helpers/sqftHelper";
import COLOR_THEMES from "../../../../../colorThemes";
import sqftConfig from "../store/sqftConfig";

export default class RenderCabinets {

  /**
   * @param points {[{x:int, y:int}]}
   * @param distance {int}
   * @return {[DiagonalPointsForTheSquareInterface]}
   */
  static getDiagonalPointsForTheSquare = (points, distance) => {
    let returnPoints = [];
    for (const pointIndex in points) {
      if (points.hasOwnProperty(pointIndex)) {
        const len = points.length;
        const current = points[+pointIndex];
        const previous = points[(+pointIndex + len - 1) % len];
        const next = points[(+pointIndex + 1) % len];

        const linePoint1 = getPointOnTheLine(current, previous, distance);
        const linePoint2 = getPointOnTheLine(current, next, distance);
        const diagonalPoint = getMidPoint(linePoint1, linePoint2);

        returnPoints.push({
          currentPoint: current,
          diagonalPoint: diagonalPoint
        });
      }
    }

    return returnPoints
  }

  /**
   * @param points {[{x:int, y:int}]}
   * @param distance {int}
   * @param linePointsIds {[]}
   * @return {[DiagonalPointsForTheSquareInterface]}
   */
  static getDiagonalPointsForTheLine = (points, distance, linePointsIds) => {
    const diagonalSquarePoint = RenderCabinets.getDiagonalPointsForTheSquare(points, distance);

    return diagonalSquarePoint.filter(squarePoint => {
      return linePointsIds.some(linePointId => {
        return linePointId === squarePoint.currentPoint.id
      });
    })
  }

  static renderCrownMolding = (ctx, crownMoldingPoints) => {
    //render diagonal lines
    ctx.beginPath();
    ctx.moveTo(crownMoldingPoints[0].diagonalPoint.x, crownMoldingPoints[0].diagonalPoint.y);
    for (const crownMoldingPoint of crownMoldingPoints) {
      ctx.lineWidth = 2;
      ctx.lineTo(crownMoldingPoint.diagonalPoint.x, crownMoldingPoint.diagonalPoint.y);
    }
    ctx.lineTo(crownMoldingPoints[0].diagonalPoint.x, crownMoldingPoints[0].diagonalPoint.y);
    ctx.stroke();
    ctx.closePath();

    //render border
    for (const crownMoldingPoint of crownMoldingPoints) {
      ctx.beginPath();
      ctx.lineWidth = 2;
      ctx.moveTo(crownMoldingPoint.currentPoint.x, crownMoldingPoint.currentPoint.y);
      ctx.lineTo(crownMoldingPoint.diagonalPoint.x, crownMoldingPoint.diagonalPoint.y);
      ctx.closePath();
      ctx.stroke();
    }
  }

  static renderEndCap = (ctx, line) => {
    //render thick line
    const fromPointField = line.from.getPointField();
    const toPointField = line.to.getPointField();
    ctx.beginPath();
    ctx.moveTo(fromPointField.x, fromPointField.y);
    ctx.lineWidth = 6;
    ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].primary_hover;
    ctx.lineTo(toPointField.x, toPointField.y);
    ctx.stroke();
    ctx.closePath();
  }
}
